import React, {Component} from 'react';
import styled from 'styled-components';
import { connect } from "react-redux";
import { CONSTANTS } from '../static/constants';
import {
  Link
} from 'react-router-dom'
import Email from '../assets/email.svg';
import Copyright from './copyright';

const LevelGrid = styled.div`
max-width: 360px;
margin: 0 auto;
  align-content: space-around;
  display: flex;
  flex-wrap: wrap;
	flex-direction: row-reverse;
	&.start {
		flex-direction: initial;
	}
	@media (max-width: 400px) {
		padding: 8px;
	}
  a {
		width: 45%;
		margin: 2.5%;
		@media (max-width: 400px) {
			width: 46%;
			margin: 2%;
		}
		&.reviewLink {
			width: 100%;
		}
	}
}
`;

const ReviewTile = styled.div`
	background-image: linear-gradient(-180deg, #0083F5 0%, #005DF6 100%);
	box-shadow: 0 1px 1px 0 rgba(0,0,0,0.15);
	border-radius: 14px;
	transition-property: all;
	transition-duration: .2s;
	padding: 2rem 0 1rem 0;
	cursor: pointer;
	text-align: center;
	
	.korean {
		width: 230px;
    font-size: 34px;
    height: 68px;
    display: flex;
    justify-content: space-around;
    color: #005df6;
    margin: 0 auto;
    padding: 18px;
    border-radius: 14px;
    background-color: #ffffff;
		transition-property: all;
		transition-duration: .35s;
	}
	.english {
		font-size: ${CONSTANTS.h4};
		margin-top: 1rem;
		line-height: 1.8rem;
		padding: 0 8px;
		color: #fff;
		display: block;
	}
	&:hover {
		box-shadow: 0 4px 12px rgba(0,0,0,0.12);
		background-image: linear-gradient(-180deg, #0083F5 14%, #005DF6 100%);
		transform: translateY(-4px);
		transition-property: all;
		transition-duration: .1s;
		.korean {
			transform: translateY(-2px);
			transition-duration: .25s;
		}
	}
	
`;

const LevelTile = styled.div`
	color: ${CONSTANTS.darkergrey};
	width: 100%;
	float: left;
	cursor: pointer;
	text-align: center;
	padding: 2rem 0 0 0;
	background-color: #fff;
	box-shadow: 0 1px 1px 0 rgba(0,0,0,0.15);
	border-radius: 14px;
	transition-property: all;
	transition-duration: .2s;
	@media (max-width: 400px) {
		padding: 32px 0 0 0;
	}
	&:hover {
		box-shadow: 0 4px 12px rgba(0,0,0,0.12);
		transform: translateY(-4px);
		transition-property: all;
		transition-duration: .1s;
		.korean {
			transform: translateY(-2px);
			transition-duration: .25s;
		}
		.stats {
			top: 48px;
			transition-duration: .2s;
		}
		.action {
			top: 0;
			transition-duration: .2s;
		}
	}
	.korean {
		font-size: 34px;
		font-weight: 700;
		width: 68px;
		height: 68px;
		margin: 0 auto;
		padding: 18px;
		border-radius: 14px;
		background-color: ${CONSTANTS.lightgrey};
		transition-property: all;
		transition-duration: .35s;
	}
	.english {
		font-size: ${CONSTANTS.h4};
		margin-top: 1rem;
		line-height: 1.8rem;
    padding: 0 8px;
	}

	.hanja {
		font-size: ${CONSTANTS.body};
		float: left;
		border-radius: 50%;
		width: 35px;
		height: 35px;
		background-color: transparent;
		padding: 10px;
		vertical-align: middle;
		text-align: center;
	}

	.word-count{
		float: right;
		font-size: ${CONSTANTS.body};
		padding-top: 10px;
	}

	&.latest {
		background-image: linear-gradient(-180deg, #0083F5 0%, #005DF6 100%);
		.tile-info-bar {
			background-color: transparent;
		}
		.korean {
			color: ${CONSTANTS.primary};
			background-color: #fff;
		}
		.hanja, .english, .word-count  {
			color: #fff
		}
		&:hover{
			background-image: linear-gradient(-180deg, #0083F5 14%, #005DF6 100%);
		}
	}
`;

const Feedback = styled.div`
  width: 100%;
  margin: 32px 0;
  a {
    display: flex;
    align-items: center;
    width: 220px;
    margin: 0 auto;
  }
	span { 
		color: ${ CONSTANTS.darkergrey };
    margin-left: 8px;
  };
`;

class LevelsGrid extends Component {
	render() {
		const {unlockedLevel, levels, needsReview, allLevelsUnlocked} = this.props
		let numLevels = this.props.unlockedLevel + 1;
		// hide latest level until review complete
		if (needsReview) { numLevels = unlockedLevel}
		// don't go beyond last level
		if (allLevelsUnlocked) { numLevels = levels.length}
		const levelsList = levels
			.slice(0, numLevels)
				.reverse().map((value, key) => {
					let latest = false;
					if (!allLevelsUnlocked && 0 === key) {
						latest = true;
					}
					return (
						<Link key={key} to={"/games/" + ((numLevels - 1) - key)}>
						<LevelTile className={latest && !needsReview ? "latest" : ""}>
							<div className="korean">{value.korean}</div>
							<div className="english">{value.english}</div>
							<div className="tile-info-bar">
								<div className="action">
									{latest && !needsReview ?
											<div><img src={require('../assets/learn.svg')} alt='Learn' />Learn</div>
											:
											<div className="grey"><img src={require('../assets/review.svg')} alt='Review' />Review</div>
									}
								</div>
								<div className="stats">
									<span className="hanja">{value.hanja}</span>
									<span className="word-count">{latest ? 0 : value.words.length } / { value.words.length}</span>
								</div>
							</div>
						</LevelTile>
						</Link>
				)
			})
	    return (
			<LevelGrid className={unlockedLevel === 0 ? 'start' : ''}>
				{this.props.needsReview ? 
					<Link to={"/games/" + (unlockedLevel) + "/review"} className="reviewLink">
						<ReviewTile>
							<div className="korean">
								<div>{levels[unlockedLevel-4].korean}</div>
                <div>{levels[unlockedLevel-3].korean}</div>
                <div>{levels[unlockedLevel-2].korean}</div>
                <div>{levels[unlockedLevel-1].korean}</div>
                
                
							</div>
							<span className="english">Review Stage</span>
						</ReviewTile>
					</Link> : ''}
				{levelsList}
        <Copyright />
			</LevelGrid>
		);
	}
}

export default connect(({ GameOptions }) => ({ needsReview: GameOptions.needs_review }))(LevelsGrid);



// WEBPACK FOOTER //
// ./src/components/levelsgrid.js